import {
  IonApp,
  IonButton,
  IonCheckbox,
  IonCol,
  IonContent,
  IonGrid,
  IonInput,
  IonItem,
  IonLabel,
  IonList,
  IonRow,
  IonSegment,
  IonSegmentButton,
  IonSelect,
  IonSelectOption,
  IonSlide,
  IonSlides,
  IonTextarea,
} from "@ionic/react";
import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import {
  getBonusPerPlayer,
  getNextGame,
  getScorePerPlayer,
  getTournamentGames,
  getUserGameBet,
  getUserTournamentPlayoff,
} from "../../calcScore";
import Leadboard from "../../components/Leadboard";
import Toolbar from "../../components/Toolbar";
import Firebase from "../../firebase";
import { URLS } from "../../urls";
import "./style.css";

//! DATAFRAME
import DataFrame from "dataframe-js";
//! SUPABASE
import { createClient } from "@supabase/supabase-js";
const supabaseUrl = "https://issdcndwoeylrjlppkti.supabase.co";
const supabaseKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJyb2xlIjoiYW5vbiIsImlhdCI6MTYxNDE5NDY2MCwiZXhwIjoxOTI5NzcwNjYwfQ.oWgYCGAJV3kzRrINUBw9Wk-XWjHjBR7BP6JyyZSIdyU";
const supabase = createClient(supabaseUrl, supabaseKey);
/*
let { data: tournament, error } = await supabase.from("tournament").select("*");
const df = new DataFrame(tournament);
console.log(df.toCollection());
console.log(df.find({ id: 1 }).toDict());
*/

declare const document: any;

var sheets = [
  { id: "1ZCE6N4x-ZWir1hMgf0iLzm1aDvp87i17XABfPAfEBwI", name: "Games" },
  { id: "1mwKdZZR9eoDsvEZXWO9xOJypQnQSiDc92CtA2HmAnKQ", name: "Leagues" },
  { id: "1W-likH1PZ365k1r-KW4ulXmPqM13fB5y13GPdg10ZeE", name: "Players" },
  { id: "1ZZLw8i52UypB_zzzopGNZvWeyc1_DSWbGq3SnnsRoDg", name: "Positions" },
  { id: "1Nxa3Xy3LrctXfr6xvnr3DOSHCAHBXXpHcM_uvtWjbZI", name: "Teams" },
  { id: "1UoRe5br5c577T1cRXwM3ETgZ63TBxZ1WOwdneJXJYt0", name: "Tournaments" },
  { id: "1oJw-uHLsF5yTpaU4WA92f6AzWczl3cVrlZcdaEjKRwM", name: "Misc" },
  { id: "1s2TcIUvcoG4w6mX4fft280bgIXOfisR8qo6B-i9n_cc", name: "Playoff" },
];

const SLIDES = [
  { url: "/sheets", label: "העלאה מטבלה" },
  { url: "/link", label: "העלאה מקישור" },
  { url: "/scores", label: "הזנת תוצאות ידנית" },
  { url: "/stats", label: "סטטיסטיקות" },
];

class Upload extends Component {
  state = {
    fb: Firebase.getInstance(),
    data: {} as any,
    users: {} as any,
    myUser: {} as any,
    tournamentID: "",
    gameID: "",
    redirect: false,
    showTeams: new Set(),
    urlNames: [],
    slides: React.createRef<HTMLIonSlidesElement>() as any,
    playersDetected: {},
    playersLeft: {},
    playersUndetected: {},
    tab: "",
  };

  async componentDidMount() {
    if (!(await this.state.fb.isEditor())) this.setState({ redirect: true });
    var data = await this.state.fb.readData("data");
    const users = await this.state.fb.readData("users");
    const myUser = await this.state.fb.getUser();

    await this.setState({ data, users, myUser });

    (document.getElementById("selectTournament") as any).value = (
      document.getElementsByClassName("upload__selectTournamentOption")[0] as any
    ).value;

    const links: any = document.getElementsByClassName("account__link");
    var moved = false;
    for (let i = 0; i < links.length; i++) {
      if (links[i].pathname === window.location.pathname) {
        links[i].firstElementChild.click();
        this.setState({ tab: "/" + links[i].pathname.split("/")[2] });
        moved = true;
      }
    }
    if (!moved) {
      links[0].firstElementChild.click();
      this.setState({ tab: "/" + links[0].pathname.split("/")[2] });
    }

    const urlNames = [];
    for (let i = 0; i < sheets.length; i++) urlNames.push(sheets[i].name);
    this.setState({ urlNames });
  }

  updateBetScores = async (newResults, gameID = this.state.gameID) => {
    var newData = this.state.data;
    if (newResults) newData = { ...newData, ...{ Results: { [gameID]: newResults } } };
    var changed = false;
    Object.keys(this.state.users.bets === undefined ? {} : this.state.users.bets).map((uid) => {
      var score = 0;
      let bet = getUserGameBet(this.state.users.bets[uid], gameID);
      if (bet) {
        bet.choice.forEach((playerNumber: any) => {
          let playerScore = getScorePerPlayer(newData, gameID, playerNumber);
          if (playerScore) score += playerScore;
          let playerBonus = getBonusPerPlayer(newData, gameID, playerNumber);
          if (playerBonus) score += playerBonus;
        });

        if (
          !this.state.users.public[uid].scores ||
          (this.state.users.public[uid].scores && this.state.users.public[uid].scores[gameID]?.score !== score)
        ) {
          this.state.fb.updateData("users/public/" + uid + "/scores", {
            [gameID]: { score, gameID },
          });
          changed = true;
        }
      }
    });
    if (changed) this.setState({ users: await this.state.fb.readData("users") });
  };

  setNewBets = async () => {
    await this.setState({ users: await this.state.fb.readData("users") });
    const bets = this.state.users.bets;
    const date = new Date().getTime();
    var changed = false;
    for (let uid in bets) {
      for (let time in bets[uid]) {
        let thisBet = bets[uid][time];
        let nextGame = getNextGame(this.state.data, thisBet.gameID);
        if (nextGame && !getUserGameBet(bets[uid], nextGame.gameID)) {
          this.state.fb.updateData("users/bets/" + uid + "/" + date, {
            ...thisBet,
            ...{ time: date, gameID: nextGame.gameID },
          });
          changed = true;
        }
      }
    }
    if (changed) this.setNewBets();
  };

  getNumbersFromCell = (title: any) => {
    var i = 0;
    while (!/^[A-Z]+$/.test(title.substr(0, title.length - i))) i++;
    return parseInt(title.substr(title.length - i, title.length));
  };

  getLettersFromCell = (title: any) => {
    var i = 0;
    while (!/^[A-Z]+$/.test(title.substr(0, title.length - i))) i++;
    return title.substr(0, title.length - i);
  };

  uploadSheet = async (sheet: any) => {
    this.state.myUser.getIdToken(/* forceRefresh */ true).then(async (idToken) => {
      let api: any = await fetch(
        "https://europe-west1-safsal-league.cloudfunctions.net/upload?sheetID=" +
          sheet.id +
          "&sheetName=" +
          sheet.name +
          "&apiKey=AIzaSyA_LTUgX1XGbfYZI-E3rqQb3zsCtneDq9g&token=" +
          idToken
      );
      const res = await api.json();
      console.log(res);

      console.log(res.sheetName);
      console.log(res.obj);

      const { data, error } = await supabase.from(res.sheetName).insert(Object.values(res.obj), {
        upsert: true,
      });
      console.log(error);
      console.log(data);
    });
  };

  getTeamPlayers = (teamNumber: any) => {
    const players: any = [];
    this.state.data.Players.map((player: any) => {
      if (player.teamNumber == teamNumber) players.push(player);
    });
    return players;
  };

  renderPlayers = () => {
    const obj: any = [];
    var counter = 0;
    this.state.data.Teams?.map((teamValue: any, teamNumber: any) => {
      if (teamValue.leagueID !== this.state.data.Games[this.state.gameID]?.leagueID) return;
      let players = this.getTeamPlayers(teamNumber);
      if (players.length > 0)
        obj.push(
          <IonRow
            className="teamRow"
            key={"teamRow" + teamNumber}
            onClick={() => {
              const showTeams = new Set(this.state.showTeams);
              if (showTeams.has(teamNumber)) showTeams.delete(teamNumber);
              else showTeams.add(teamNumber);
              this.setState({ showTeams });
            }}
          >
            {teamValue.teamName}
          </IonRow>
        );

      players.map((playerValue: any) => {
        obj.push(
          <IonRow
            key={"row" + playerValue.playerNumber}
            style={{ display: this.state.showTeams.has(teamNumber) ? "flex" : "none" }}
          >
            <IonCol className="upload__col1">{playerValue.playerName}</IonCol>
            <IonCol className="upload__col2">
              <IonInput
                type="number"
                data-playerNumber={playerValue.playerNumber}
                className="upload__input upload__inputScore"
                placeholder="ניקוד"
              />
            </IonCol>
            <IonCol className="upload__col2">
              <IonInput
                type="number"
                data-playerNumber={playerValue.playerNumber}
                className="upload__input upload__inputBonus"
                placeholder="בונוס"
              />
            </IonCol>
          </IonRow>
        );
      });
    });
    return obj;
  };

  renderRedirect = () => {
    if (this.state.redirect) return <Redirect to="/" />;
  };

  render() {
    return (
      <IonApp>
        {this.renderRedirect()}
        <Toolbar />
        <IonContent>
          <IonSegment scrollable={true} value={window.location.pathname} className="account__segment">
            {SLIDES.map((slideValue: any, slideIndex) => {
              return (
                <Link key={"slide" + slideIndex} className="account__link" to={URLS.UPLOAD.url + slideValue.url}>
                  <IonSegmentButton
                    onClick={() => {
                      this.state.slides.current.slideTo(slideIndex);
                      this.setState({ tab: slideValue.url });
                    }}
                  >
                    {slideValue.label}
                  </IonSegmentButton>
                </Link>
              );
            })}
          </IonSegment>
          <div style={{ display: this.state.tab === "/sheets" ? "none" : "block" }}>
            <IonSelect
              id="selectTournament"
              placeholder="בחירת טורניר"
              interface="popover"
              className="myteam__selectGame"
              onIonChange={async (e: any) => {
                (document.getElementById("gameSelect") as any).value = "";
                await this.setState({ tournamentID: e.detail.value });

                const games = getTournamentGames(this.state.data, this.state.tournamentID);
                games.forEach((game: any) => {
                  this.updateBetScores(null, game.gameID);
                });
              }}
            >
              {this.state.data.Tournaments?.map((tournamentValue: any, tournamentIndex: any) => {
                if (tournamentValue)
                  return (
                    <IonSelectOption
                      className="upload__selectTournamentOption"
                      value={tournamentIndex}
                      key={"tournament" + tournamentIndex}
                    >
                      {tournamentValue.tournamentDesc}
                    </IonSelectOption>
                  );
              })}
            </IonSelect>
            <br />
            <IonSelect
              id="gameSelect"
              placeholder="בחירת מחזורים"
              interface="popover"
              className="myteam__selectGame"
              // disabled={!this.state.tournamentID}
              onIonChange={async (e: any) => {
                const gameID = e.detail.value;
                await this.setState({ gameID });

                const scoreInputs: any = document.getElementsByClassName("upload__inputScore");
                const bonusInputs: any = document.getElementsByClassName("upload__inputBonus");
                for (let i = 0; i < scoreInputs.length; i++) {
                  let playerScore =
                    this.state.data.Results &&
                    this.state.data.Results[gameID] &&
                    this.state.data.Results[gameID][scoreInputs[i].dataset.playerNumber];
                  if (playerScore?.score) scoreInputs[i].value = playerScore.score;
                  if (playerScore?.bonus) bonusInputs[i].value = playerScore.bonus;
                }
              }}
            >
              {this.state.data.Games?.map((gameValue: any, gameIndex: any) => {
                if (gameValue.tournamentID == this.state.tournamentID)
                  return (
                    <IonSelectOption value={gameValue.gameID} key={"game" + gameIndex}>
                      {gameValue.description}
                    </IonSelectOption>
                  );
              })}
            </IonSelect>
            <br />
          </div>
          <IonSlides ref={this.state.slides} options={{ allowTouchMove: false }} className="upload__slides">
            <IonSlide className="account__slide">
              <IonList>
                {this.state.urlNames.map((name) => {
                  return (
                    <IonItem key={name}>
                      <IonLabel>{name}</IonLabel>
                      <IonCheckbox slot="end" />
                    </IonItem>
                  );
                })}
              </IonList>
              <br />
              <IonButton
                onClick={() => {
                  const checkboxs = document.getElementsByTagName("ion-checkbox");
                  for (let i = 0; i < checkboxs.length; i++) {
                    if (checkboxs[i].checked) this.uploadSheet(sheets[i]);
                  }
                  setTimeout(() => {
                    // this.setNewBets();
                  }, 500);
                }}
              >
                Upload Sheets
              </IonButton>
            </IonSlide>
            <IonSlide className="account__slide">
              <div
                style={{ cursor: "pointer", color: "var(--ion-color-primary, #3880ff)" }}
                onClick={() => {
                  const currPlayoff = this.state.data.Playoff[this.state.tournamentID];
                  const teams = [];
                  let teamIdx = 1;
                  while ("team" + teamIdx in currPlayoff) {
                    teams.push(this.state.data.Teams[currPlayoff["team" + teamIdx]].teamName);
                    teamIdx++;
                  }
                  console.log(teams);

                  const rows = [["uid"].concat(teams)];
                  const playoffs = this.state.users["playoff"];
                  for (let uid in playoffs) {
                    let userPlayoff = getUserTournamentPlayoff(playoffs[uid], this.state.tournamentID);
                    if (userPlayoff) {
                      let row = [uid].concat(
                        userPlayoff.choice.reduce((acc, cur) => {
                          return acc.concat(cur);
                        }, [])
                      );
                      rows.push(row);
                    }
                  }
                  let csvContent =
                    "data:text/csv;charset=utf-8," +
                    String.fromCharCode(0xfeff) +
                    rows.map((e) => e.join(",")).join("\n");
                  var encodedUri = encodeURI(csvContent);
                  var link = document.createElement("a");
                  link.setAttribute("href", encodedUri);
                  link.setAttribute("download", "playoffs_tournament_" + this.state.tournamentID + ".csv");
                  document.body.appendChild(link); // Required for FF

                  link.click(); // This will download the data file named "my_data.csv".
                }}
              >
                הורדת תוצאות הפלייאוף
              </div>
              <IonTextarea id="linksArea" className="upload__links" />
              <br />
              <div>כל קישור בשורה חדשה</div>
              <a href="https://ibasketball.co.il" target="_blank" rel="noopener noreferrer">
                איגוד הכדורסל בישראל
              </a>
              <br />
              <IonButton
                disabled={!this.state.gameID}
                onClick={async () => {
                  const urls = document.getElementById("linksArea").value;
                  this.state.myUser.getIdToken(/* forceRefresh */ true).then((idToken) => {
                    urls.split("\n").forEach(async (url) => {
                      if (!url.trim()) return;
                      let api = await fetch(
                        "https://europe-west1-safsal-league.cloudfunctions.net/updateScoreFromURL?gameID=" +
                          this.state.gameID +
                          "&url=" +
                          url +
                          "&token=" +
                          idToken
                      );
                      const res = await api.json();
                      res.playersDetected = {
                        ...this.state.playersDetected,
                        ...res.playersDetected,
                      };
                      res.playersLeft = {
                        ...this.state.playersLeft,
                        ...res.playersLeft,
                      };
                      for (let i in res.playersLeft) {
                        if (i in res.playersDetected) delete res.playersLeft[i];
                      }
                      this.setState({
                        playersDetected: res.playersDetected,
                        playersUndetected: {
                          ...this.state.playersUndetected,
                          ...res.playersUndetected,
                        },
                        playersLeft: res.playersLeft,
                      });
                    });
                  });
                }}
              >
                Upload
              </IonButton>
              <br />
              <div>
                <h2 className="teamRow">שחקנים שעודכנו</h2>
                {Object.values(this.state.playersDetected).map((player: any) => {
                  return (
                    <div key={"detected" + player.playerNumber}>
                      {player.playerName}, {this.state.data.Teams[player.teamNumber].teamName},{" "}
                      <div className="upload__logScore">
                        {player.score}, בונוס={player.bonus}
                      </div>
                    </div>
                  );
                })}
                <h2 className="teamRow">שחקנים שלא נמצאו</h2>
                {Object.values(this.state.playersUndetected).map((player: any) => {
                  return (
                    <div key={"undetected" + player.playerName}>
                      {player.playerName},{player.teamName} , <div className="upload__logScore">{player.score}</div>
                    </div>
                  );
                })}
                <h2 className="teamRow">שחקנים שלא עודכנו</h2>
                {Object.values(this.state.playersLeft).map((player: any) => {
                  return (
                    <div key={"left" + player.playerNumber}>
                      {player.playerName}, {this.state.data.Teams[player.teamNumber].teamName}
                    </div>
                  );
                })}
              </div>
              <br />
              <IonButton
                disabled={Object.keys(this.state.playersDetected).length === 0}
                onClick={async () => {
                  const data: any = {};
                  for (let playerID in this.state.playersDetected) {
                    let player: any = this.state.playersDetected[playerID];
                    data[player.playerNumber] = {
                      playerNumber: player.playerNumber,
                      score: player.score,
                      bonus: player.bonus,
                    };
                  }
                  await this.state.fb.updateData("data/Results/" + this.state.gameID, data);
                  this.updateBetScores({ ...this.state.data.Results, ...data });
                }}
              >
                אישור והעלאה
              </IonButton>
              <br />
            </IonSlide>
            <IonSlide className="account__slide">
              <IonGrid>{this.renderPlayers()}</IonGrid>
              <br />
              <IonButton
                disabled={!this.state.gameID}
                onClick={async () => {
                  const scoreInputs: any = document.getElementsByClassName("upload__inputScore");
                  const bonusInputs: any = document.getElementsByClassName("upload__inputBonus");
                  const gameRes: any = {};
                  for (let i = 0; i < scoreInputs.length; i++) {
                    let playerNumber = scoreInputs[i].dataset.playerNumber;
                    gameRes[playerNumber] = {};
                    if (scoreInputs[i].value)
                      gameRes[playerNumber] = {
                        ...gameRes[playerNumber],
                        ...{
                          score: scoreInputs[i].value,
                          playerNumber: playerNumber,
                        },
                      };
                    if (bonusInputs[i].value)
                      gameRes[playerNumber] = {
                        ...gameRes[playerNumber],
                        ...{
                          bonus: bonusInputs[i].value,
                          playerNumber: playerNumber,
                        },
                      };
                  }
                  await this.state.fb.updateData("data/Results/" + this.state.gameID, gameRes);
                  this.updateBetScores({ ...this.state.data.Results, ...gameRes });
                }}
              >
                שמירת ניקוד
              </IonButton>
              <br />
            </IonSlide>
            <IonSlide className="account__slide">
              <IonGrid>
                {this.state.data.Games?.map((gameValue: any, gameIndex: any) => {
                  if (gameValue.tournamentID == this.state.tournamentID) {
                    var active = 0;
                    Object.values(this.state.users.bets === undefined ? {} : this.state.users.bets)?.map(
                      (userBets: any) => {
                        let found = false;
                        Object.values(userBets).map((bet: any) => {
                          if (bet.gameID === gameValue.gameID) {
                            found = true;
                          }
                        });
                        if (found) active++;
                      }
                    );
                    return (
                      <IonRow key={"game" + gameIndex}>
                        <IonCol>{gameValue.description}</IonCol>
                        <IonCol>{active} משתמשים</IonCol>
                      </IonRow>
                    );
                  }
                })}
              </IonGrid>
              <br />
              <Leadboard
                data={this.state.data}
                users={this.state.users.public}
                userBets={this.state.users.bets}
                tournamentID={this.state.tournamentID}
                gameID={"total"}
                rowsNum={-1}
                uid={this.state.myUser.uid}
                showID
                showBets
                filterActivity
              />
            </IonSlide>
          </IonSlides>
        </IonContent>
      </IonApp>
    );
  }
}

export default Upload;
